import React, { FunctionComponent } from 'react';
import { Stepper, StepperStep } from '../../shared/Stepper';
import { Step1, Step2, Step3 } from './steps';


interface StepsArray {
    component: FunctionComponent<{ id: number }>;
}

const steps: StepsArray[] = [
    {
        component: Step1,
    },
    {
        component: Step2,
    },
		{
				component: Step3,
		},
];

export const SurPlusStepper = () => {
    return (
        <Stepper
            defaultUrl={'https://www.hypotheker.nl'}
            defaultPreviousText="Terug"
						previousButtonTexts={['Huidige woning', 'Bijkomende komsten', 'Huidige hypotheek']}>
            {steps &&
                steps.map((step, key) => (
                    <StepperStep id={key} key={key}>
                        <step.component id={key} />
                    </StepperStep>
                ))}

        </Stepper>
    );
};
